//           <SmsTabs /* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Swal from "sweetalert2";
import ProductDetailsTabs from "./productDetailsTabs";
import BillingTabs from "./billingTabs";
import KeywordTabs from "./keywordTabs";
import ChargingConfigTabs from "./chargingConfigTabs";
import FallbackTabs from "./fallbackTabs";
import SmsTabs from "./smsTabs";
import PartnerNotificationTabs from "./partnerNotificationTabs";
import CustNotificationTabs from "./custNotificationTabs";
import "./addProduct.css";

const AddProduct = ({
  setAddProductModal,
  getAllData,
  productData,
  serviceId,
}) => {
  const [activeTab, setActiveTab] = useState("productDetails");
  const [productId, setProductId] = useState(null);
  const [renewalType, setRenewalType] = useState(null);
  
  // Add state to track completed tabs
  const [completedTabs, setCompletedTabs] = useState({
    productDetails: false,
    billing: false,
    keyword: false,
    chargingConfig: false,
    fallback: false,
    sms: false,
    partnerNotification: false,
    customerNotification: false
  });
console.log("completedTabs",completedTabs)
  // Define tab order with both display and state names
  const tabOrder = [
    { display: "Product Details", state: "productDetails" },
    { display: "Billing", state: "billing" },
    { display: "Keyword", state: "keyword" },
    { display: "Charging Config", state: "chargingConfig" },
    { display: "Fallback", state: "fallback" },
    { display: "SMS", state: "sms" },
    { display: "Partner Notification", state: "partnerNotification" },
    { display: "Customer Notification", state: "customerNotification" }
  ];

  const handleProductCreated = (newProductId) => {
    setProductId(newProductId);
    setCompletedTabs(prev => ({
      ...prev,
      productDetails: true
    }));
  };

  const handleBillingSubmit = (renewalType) => {
    setRenewalType(renewalType);
    setCompletedTabs(prev => ({
      ...prev,
      billing: true
    }));
  };

  // Updated function to check if a tab is accessible
  const isTabAccessible = (tabState) => {
    const currentIndex = tabOrder.findIndex(tab => tab.state === activeTab);
    const targetIndex = tabOrder.findIndex(tab => tab.state === tabState);
    
    // Always allow going back to previous tabs
    if (targetIndex < currentIndex) {
      return true;
    }
    
    // Allow current tab
    if (targetIndex === currentIndex) {
      return true;
    }
    
    // Allow next tab only if current is completed
    if (targetIndex === currentIndex + 1) {
      return completedTabs[activeTab];
    }
    
    return false;
  };

  const handleTabChange = (tabState) => {
    const targetIndex = tabOrder.findIndex(tab => tab.state === tabState);
    const currentIndex = tabOrder.findIndex(tab => tab.state === activeTab);

    // If trying to go forward
    if (targetIndex > currentIndex) {
      if (!completedTabs[activeTab]) {
        // Mark current tab as completed before moving forward
        setCompletedTabs(prev => ({
          ...prev,
          [activeTab]: true
        }));
      }
    }
    
    setActiveTab(tabState);
  };

  // Function to mark tab as completed and move to next tab
  const handleTabComplete = (tabState) => {
    setCompletedTabs(prev => ({
      ...prev,
      [tabState]: true
    }));
    
    const nextTabIndex = tabOrder.findIndex(tab => tab.state === tabState) + 1;
    if (nextTabIndex < tabOrder.length) {
      setActiveTab(tabOrder[nextTabIndex].state);
    }
  };

  return (
    <form className="form-horizontal">
      <ul className="nav nav-tabs mb-3">
        {tabOrder.map((tab) => {
          const isCompleted = completedTabs[tab.state];
          const isActive = activeTab === tab.state;
          const canAccess = isTabAccessible(tab.state);
          
          return (
            <li className="nav-item" key={tab.state}>
              <a
                className={`nav-link ${isActive ? "active" : ""} 
                  ${!canAccess ? "disabled" : ""}
                  ${isCompleted ? "completed" : ""}`}
                onClick={() => canAccess && handleTabChange(tab.state)}
                style={{
                  cursor: canAccess ? 'pointer' : 'not-allowed',
                  color: isCompleted ? '#28a745' : 
                         isActive ? '#007bff' : 
                         !canAccess ? '#6c757d' : '#212529',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <span className="tab-icon">
                  {isCompleted ? (
                    <i className="fas fa-check-circle" style={{ color: '#28a745' }}></i>
                  ) : (
                    <i className="fas fa-times-circle" style={{ color: '#dc3545' }}></i>
                  )}
                </span>
                {tab.display}
              </a>
            </li>
          );
        })}
      </ul>

      <div className="tab-content">
        {activeTab === "productDetails" && (
          <ProductDetailsTabs
            setAddProductModal={setAddProductModal}
            setActiveTab={setActiveTab}
            serviceId={serviceId}
            onProductCreated={handleProductCreated}
            onComplete={() => handleTabComplete("productDetails")}
          />
        )}

        {activeTab === "billing" && (
          <BillingTabs
            productId={productId}
            setActiveTab={setActiveTab}
            serviceId={serviceId}
            onBillingSubmit={handleBillingSubmit}
            onComplete={() => handleTabComplete("billing")}
          />
        )}

        {activeTab === "keyword" && (
          <KeywordTabs
            productId={productId}
            setActiveTab={setActiveTab}
            onComplete={() => handleTabComplete("keyword")}
          />
        )}

        {activeTab === "chargingConfig" && (
          <ChargingConfigTabs
            productId={productId}
            setActiveTab={setActiveTab}
            renewalType={renewalType}
            onComplete={() => handleTabComplete("chargingConfig")}
          />
        )}

        {activeTab === "fallback" && (
          <FallbackTabs
            productId={productId}
            setActiveTab={setActiveTab}
            onComplete={() => handleTabComplete("fallback")}
          />
        )}

        {activeTab === "sms" && (
          <SmsTabs
            productId={productId}
            setActiveTab={setActiveTab}
            onComplete={() => handleTabComplete("sms")}
          />
        )}

        {activeTab === "partnerNotification" && (
          <PartnerNotificationTabs
            productId={productId}
            setActiveTab={setActiveTab}
            onComplete={() => handleTabComplete("partnerNotification")}
          />
        )}

        {activeTab === "customerNotification" && (
          <CustNotificationTabs
            productId={productId}
            setActiveTab={setActiveTab}
            serviceId={serviceId}
            setAddProductModal={setAddProductModal}
            getAllData={getAllData}
            onComplete={() => handleTabComplete("customerNotification")}
          />
        )}
      </div>
    </form>
  );
};

export default AddProduct;
